export interface IDictionary {
    add(key: string, value: any): void;
    remove(key: string): void;
    containsKey(key: string): boolean;
    keys(): string[];
    values(): any[];
}

export abstract class Dictionary implements IDictionary {
    _keys: string[] = [];
    _values: any[] = [];

    constructor(init: { key: string; value: any; }[]) {
        const multivalues: { key: string; value: any; }[] = [];

        for (const [keyEntry, valueEntry] of Object.entries(init)) {
            if (!(valueEntry instanceof Array)) {
                this.addToDictionary(keyEntry, valueEntry);
            } else {
                multivalues.push({ key: keyEntry, value: valueEntry });
            }
        }

        multivalues.forEach(multivalue => {
            this.addToDictionary(multivalue.key, multivalue.value);
        });
    }
    private addToDictionary(key: string, value: any): any {
        this[key] = value;
        this._keys.push(key);
        this._values.push(value);
    }



    add(key: string, value: any) {
        this[key] = value;
        this._keys.push(key);
        this._values.push(value);
    }

    remove(key: string) {
        const index = this._keys.indexOf(key, 0);
        this._keys.splice(index, 1);
        this._values.splice(index, 1);

        delete this[key];
    }

    size(): number {
        return this._keys ? this._keys.length : 0;
    }

    keys(): string[] {
        return this._keys;
    }

    values(): any[] {
        return this._values;
    }

    containsKey(key: string) {
        if (this[key] === undefined) {
            return false;
        }

        return true;
    }

    toLookup(): IDictionary {
        return this;
    }
}
